export enum MenuState {
	PartnerAdmin,
	AccountAdmin,
	GlobalAdmin,
	FeatureFlagsAdmin
}
